import { Routes as DomRoutes, Route } from "react-router-dom";
import { LoginPage } from "src/pages/auth/login/LoginPage";
import HomePage from "src/pages/home/HomePage";
import PrivateRoute from "./PrivateRoute";
import { MainRoutePage } from "src/pages/MainRoutePage";
import { RegisterPage } from "src/pages/register/RegisterPage";
import { UserRegisterInfo } from "src/pages/register/UserRegisterInfo";
import FinishPage from "src/pages/register/FinishPage";
import { DietPage } from "src/pages/diet/DietPage";
import { MyInfoPage } from "src/pages/myInfo/MyInfoPage";
import SettingPage from "src/pages/myInfo/components/SettingPage";
import FixInfoPage from "src/pages/myInfo/components/FixInfoPage";
import FamilyInfoPage from "src/pages/myInfo/FamilyInfoPage";
import InvitePage from "src/pages/myInfo/InvitePage";
import ServicePage from "src/pages/customer/ServicePage";
import FAQPage from "src/pages/customer/FQAPage";
import PolicyPage from "src/pages/terms/PolicyPage";
import { PointBoxPage } from "src/pages/point/PointBoxPage";
import { HealthReportPage } from "src/pages/report/HealthReportPage";
import { SocialCallbackPage } from "src/pages/auth/login/SocialCallbackPage";
import { HealthPointPage } from "src/pages/home/HealthPointPage";
import { PillPage } from "src/pages/pill/PillPage";
import { WalkPage } from "src/pages/walk/WalkPage";
import { DietWirtePage } from "src/pages/diet/components/DietWritePage";
import { PillWritePage } from "src/pages/pill/components/PillWritePage";
import { AlertCenter } from "src/pages/alert/AlertCenter";
import { AlertSetting } from "src/pages/alert/AlertSetting";
import { PointBoxDetails } from "src/pages/point/components/PointBoxDetails";
import { PointBoxChange } from "src/pages/point/components/PointBoxChange";
import { PointBoxChangeList } from "src/pages/point/components/PointBoxChangeList";
import { PointGiftDetail } from "src/pages/point/components/PointGiftDetail";
import { LoginPageNormal } from "src/pages/auth/login/LoginPageNormal";
import { AdminPage } from "src/pages/admin/AdminPage";
import { AdminMainPage } from "src/pages/admin/AdminMainPage";

interface RouterItem {
  path: string;
  element: React.ReactNode;
  withAuthorization: boolean;
}

const routerItems: RouterItem[] = [
  {
    path: "/auth/login",
    element: <LoginPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/login/normal",
    element: <LoginPageNormal />,
    withAuthorization: false,
  },
  /* 회원가입 */
  {
    path: "/register/:reg",
    element: <RegisterPage />,
    withAuthorization: false,
  },
  /* 가입 시 기본정보 입력 */
  {
    path: "/register/userInfo/:reg",
    element: <UserRegisterInfo />,
    withAuthorization: false,
  },
  /* 가입 성공 시 */
  {
    path: "/register/success/:reg",
    element: <FinishPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/callback",
    element: <SocialCallbackPage />,
    withAuthorization: false,
  },
  {
    path: "/admin",
    element: <AdminMainPage />,
    withAuthorization: false,
  },
  {
    path: "/admin/users",
    element: <AdminPage />,
    withAuthorization: false,
  },
  {
    path: "/admin/logs",
    element: <AdminPage />,
    withAuthorization: false,
  },
  { path: "/", element: <HomePage />, withAuthorization: true },
  /* 건강 포인트 */
  {
    path: "/healthPoint",
    element: <HealthPointPage />,
    withAuthorization: true,
  },
  /* 알림 센터 */
  {
    path: "/alert",
    element: <AlertCenter />,
    withAuthorization: true,
  },
  /* 알림 센터 */
  {
    path: "/alert/setting",
    element: <AlertSetting />,
    withAuthorization: true,
  },
  /* 약관 동의 */
  {
    path: "/register",
    element: <RegisterPage />,
    withAuthorization: true,
  },
  /* 가입 시 기본정보 입력 */
  {
    path: "/register/userInfo",
    element: <UserRegisterInfo />,
    withAuthorization: true,
  },
  /* 가입 성공 시 */
  {
    path: "/register/success",
    element: <FinishPage />,
    withAuthorization: true,
  },
  /* 내정보 */
  {
    path: "/myinfo",
    element: <MyInfoPage />,
    withAuthorization: true,
  },
  /* 계정관리 */
  {
    path: "/mysetting",
    element: <SettingPage />,
    withAuthorization: true,
  },
  /* 건강 정보 수정 */
  {
    path: "/mysetting/fixinfo",
    element: <FixInfoPage />,
    withAuthorization: true,
  },
  /* 가족 정보 페이지 */
  {
    path: "/myinfo/family",
    element: <FamilyInfoPage />,
    withAuthorization: true,
  },
  /* 초대하기 페이지 */
  {
    path: "/myinfo/invite",
    element: <InvitePage />,
    withAuthorization: true,
  },
  /* 고객센터 페이지 */
  {
    path: "/service",
    element: <ServicePage />,
    withAuthorization: true,
  },
  /* 1:1 문의 페이지  */
  {
    path: "/service/faq",
    element: <FAQPage />,
    withAuthorization: true,
  },
  /* 약관 및 정책 페이지 */
  {
    path: "/policy",
    element: <PolicyPage />,
    withAuthorization: true,
  },
  /* 건강리포트 페이지 */
  {
    path: "/report",
    element: <HealthReportPage />,
    withAuthorization: true,
  },
  /* 포인트 페이지 */
  {
    path: "/point",
    element: <PointBoxPage />,
    withAuthorization: true,
  },
  /* 포인트박스 상세페이지 */
  {
    path: "/point/details",
    element: <PointBoxDetails />,
    withAuthorization: true,
  },
  /* 포인트박스 교환 페이지 */
  {
    path: "/point/change",
    element: <PointBoxChange />,
    withAuthorization: true,
  },
  /* 포인트박스 교환내역 페이지 */
  {
    path: "/point/changeList",
    element: <PointBoxChangeList />,
    withAuthorization: true,
  },
  /* 포인트박스 교환내역 페이지 */
  {
    path: "/point/giftDetails",
    element: <PointGiftDetail />,
    withAuthorization: true,
  },
  /* 식단 페이지 */
  {
    path: "/diet",
    element: <DietPage />,
    withAuthorization: true,
  },
  /* 식단 기록 페이지 */
  {
    path: "/diet/write",
    element: <DietWirtePage />,
    withAuthorization: true,
  },
  {
    path: "/diet/write/:mode",
    element: <DietWirtePage />,
    withAuthorization: true,
  },
  /* 복약 페이지 */
  {
    path: "/pill",
    element: <PillPage />,
    withAuthorization: true,
  },
  {
    path: "/pill/write",
    element: <PillWritePage />,
    withAuthorization: true,
  },
  /* 걷기 페이지 */
  {
    path: "/walk",
    element: <WalkPage />,
    withAuthorization: true,
  },
];

export function Routes() {
  return (
    <DomRoutes>
      <Route element={<MainRoutePage />}>
        {routerItems
          .filter((route) => route.withAuthorization)
          .map((route: RouterItem) => {
            return (
              <Route
                key={route.path}
                path={route.path}
                element={<PrivateRoute component={route.element} />}
              />
            );
          })}
        <Route
          path="*"
          element={
            <div style={{ marginTop: "52px" }}>존재하지 않는 페이지입니다.</div>
          }
        />
      </Route>

      {routerItems
        .filter((route) => !route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
    </DomRoutes>
  );
}
